module.exports = __webpack_public_path__ + "img/ic_dl.340b202f.svg";